import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/UploadEngagementReportFromInsightCheck.graphql';
import { Mutation, MutationuploadEngagementReportFromInsightCheckArgs } from '../../__generated__/globalTypes';

export const useUploadEngagementReportFromInsightCheckMutation = (
  options?: MutationHookOptions<Mutation, MutationuploadEngagementReportFromInsightCheckArgs>
) => {
  const [callUploadEngagementReportFromInsightCheck, result] = useMutation<
    Mutation,
    MutationuploadEngagementReportFromInsightCheckArgs
  >(MUTATION, options);

  return { callUploadEngagementReportFromInsightCheck, ...result };
};

export type UploadEngagementReportFromInsightCheckMutationFunction = Mutation['uploadEngagementReportFromInsightCheck'];
